<template>
<!-- Main row -->
   <v-card flat>
      <v-card-text class="p-0 m-0">
            <v-layout row wrap>
 
          <v-flex xs12  md12   style="background-color:#ddd" >
           <v-toolbar color="primary" dark tabs>
                <v-toolbar-title v-if="active==0">Dialer</v-toolbar-title>
                <v-toolbar-title v-else-if="active==1">Favourite</v-toolbar-title>
                <v-toolbar-title v-else-if="active==2">Recent Logs</v-toolbar-title>
                <v-toolbar-title v-else-if="active==3">Contacts</v-toolbar-title>
              
              
               <v-spacer></v-spacer>
               <!-- <v-btn small icon  v-on:click="openphone=false" class="pl-0" ><v-icon   >close</v-icon></v-btn>-->
                <v-btn small icon  :to="`/voip-conversations/${dtomenuid}/details`"   ><v-icon   >more_vert</v-icon></v-btn>
            
               <template slot="extension">
                      <v-tabs  v-model="active"    color="primary"    grow     >
                           <v-tabs-slider color="pink"></v-tabs-slider>
                           <v-tab >   <v-icon>dialpad</v-icon>  </v-tab>
                           <v-tab >   <v-icon>star</v-icon>  </v-tab>
                          <!-- <v-tab >   <v-icon>update</v-icon>  </v-tab>-->
                           <v-tab >   <v-icon>people</v-icon>  </v-tab>
                       <!--<v-spacer></v-spacer>
                       <v-btn icon  >  <v-icon>add</v-icon>  </v-btn>
                       <v-btn icon  >  <v-icon>refresh</v-icon>  </v-btn>-->
                      </v-tabs>  
               </template >       
                      
                      
                      
                      
                      
                   </v-toolbar>    
                       
                      <v-tabs-items v-model="active">  
                           <v-tab-item>
                              <Dialer2 />
                           </v-tab-item>
                           
                            <v-tab-item>
                           
                               
                                  <v-card v-for="(flist, index) in favcontacts" :key="`ffcc${flist.id}`" class="m-2 elevation-1">
                                   
                                   
                                     <v-list-tile        avatar  @click=""  :to="`/contacts/info/${flist.id}`">
                                        <v-list-tile-avatar>
                                           <v-btn flat icon color="pink" v-on:click="">
                                              <v-icon v-if="flist.favorite_status==1" color="pink">star</v-icon>
                                              <v-icon v-else color="pink">star_border</v-icon>
                                           </v-btn>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                           <v-list-tile-title>{{ flist.firstname }}</v-list-tile-title>
                                           <v-list-tile-sub-title>{{ flist.email }}</v-list-tile-sub-title>
                                           <v-list-tile-sub-title>{{ flist.phone }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                           <v-btn icon ripple :to="`/contacts/info/${flist.id}`">
                                              <v-icon color="grey lighten-1">info</v-icon>
                                           </v-btn>
                                        </v-list-tile-action>
                                     </v-list-tile>
                                    
                                    <!-- <v-divider  v-if="index + 1 < favcontacts.length"   :key="`dfcc${flist.id}`"  ></v-divider>-->
                                 	 
                                  </v-card>
                             
                             
                            </v-tab-item>
                            
                            <!--<v-tab-item>
                              <RecentKafkaPop/>
                           </v-tab-item>-->
                           
                            <v-tab-item>
                              <v-card>
                                   <v-list  >
                                      <template v-for="(flist, index) in favcontacts">
                                         <v-list-tile     :key="`ffcc${flist.id}`"   avatar  @click=""  :to="`/contacts/info/${flist.id}`">
                                            <v-list-tile-avatar>
                                               <v-avatar color="teal" size="38px" >
                                                  <span class="white--text title font-weight-bold">{{ flist.firstname.charAt(0).toUpperCase() }}</span>
                                                </v-avatar>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                               <v-list-tile-title>{{ flist.firstname }}</v-list-tile-title>
                                                <v-list-tile-sub-title>{{ flist.email }}</v-list-tile-sub-title>
                                               <v-list-tile-sub-title>{{ flist.phone }}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                               <v-btn icon ripple :to="`/contacts/info/${flist.id}`">
                                                  <v-icon color="grey lighten-1">info</v-icon>
                                               </v-btn>
                                            </v-list-tile-action>
                                         </v-list-tile>
                                         <v-divider  v-if="index + 1 < favcontacts.length"   :key="`dfcc${flist.id}`" class="m-0 p-0" ></v-divider>
                                      </template>
                                   </v-list>
                                </v-card>
                           </v-tab-item>
                    </v-tabs-items>
               
               
             		<!-- <RecentKafka />-->
                </v-flex>
       </v-layout>
   </v-card-text>
  </v-card>
<!-- /.row (main row) -->
</template>

<script>

//import Twilio from 'twilio'
//import Countryphoneselect from '../Includes/Countryphoneselect.vue';
import Dialer2 from './Dialer.vue';
import RecentKafkaPop from '../Voip/RecentKafkaPop.vue'; 

export default {
  name: 'Dialer',
  data() {
    return {
       active: 0,
	     
    }
  },
  created: function(){ 
		  this.$store.dispatch('getcontacts',{pagecount:20,type:'',pagelength:1})
  },components: {
		//Countryphoneselect,
		Dialer2,
		RecentKafkaPop
  },mounted() {	
		//this.getProfile();
		
  },computed: {
     userid () {
	   if(this.$store.state.user){
			if(typeof this.$store.state.user.uid!=='undefined'){
				return this.$store.state.user.uid;
			}else{
				return '';
			}
		}else{
				return '';
			}
	},
	openphone:{
		get: function () {
			return this.$store.state.openphone;
		},
		set: function (newValue) {
			this.$store.state.openphone = newValue
		}
	},
	 favcontacts(){
			return this.$store.state.contacts.filter(function (ct) { return parseInt(ct.favorite_status) ===  1 })
	},dtomenuid:{
		get: function () {
			return this.$store.state.dtomenuid;
		},
		set: function (newValue) {
			this.$store.state.dtomenuid = newValue
		}
	},
     
  },methods: {
    

  }
}
</script>
 
 
<style>
    
  </style>



// WEBPACK FOOTER //
// src/components/Inbrowser/Pop.vue